import React from 'react';
import { SearchComponentMobileToggle } from '@spothero/search-component';
import { Box, Flex } from '@spothero/ui';
import { useDispatch, useSelector } from 'react-redux';
import useIsMobile from 'hooks/use-is-mobile';
import { useReduxSearchState } from 'pages/search/hooks/use-redux-search-state';
import MobileViewToggle from 'pages/search/components/search-component/mobile-view-toggle';
import { FilterSelection } from 'pages/search/components/filters/FilterSelection';
import { MobileSearchModal } from '../mobile-search-modal/MobileSearchModal';
// import {useShowEventsData} from 'pages/search/hooks/use-show-events-data';
import { setSearchComponentIsOpen } from 'store/search/search-actions';
import { trackSearchEditButtonClicked } from 'segment/events/search-edit-button-clicked';
import { IMMEDIATE_FEATURES } from 'utils/experiment';
import { OPTIMIZELY_FEATURE_ON, useFeatureVariation, } from 'plugins/optimizely/hooks/use-feature-variation';
const ToggleWrapper = ({ onOpen, showAirportMobileWebMap, }) => {
    const iconStyleProps = {
        fill: 'white',
        backgroundColor: 'primary.default',
        borderRadius: 'md',
        width: '6',
        height: '6',
        padding: '1',
        marginLeft: '1',
    };
    const textStyleProps = {
        paddingLeft: '2',
    };
    return (<Flex paddingX="4">
            <SearchComponentMobileToggle onClick={onOpen} 
    // Todo - we probably want to move this styling into the component.  Having it separate is a bit confusing
    // @ts-expect-error - typing mismatch
    iconStyleProps={iconStyleProps} topTextStyleProps={{ ...textStyleProps, lineHeight: '16px' }} bottomTextStyleProps={{ ...textStyleProps, lineHeight: '24px' }} styleProps={{ paddingX: 3 }}/>
            <MobileViewToggle showAirportMobileWebMap={showAirportMobileWebMap}/>
        </Flex>);
};
export const MobileSearchComponent = () => {
    const isOpen = useSelector((state) => state.search.data.searchComponentIsOpen);
    // const {showSEMEvent} = useShowEventsData();
    const reduxState = useReduxSearchState();
    const isMobile = useIsMobile();
    const dispatch = useDispatch();
    // Evaluated unconditionally (not gated behind `!isOpen`) so every mobile
    // user gets bucketed/exposed, not just while the search bar is collapsed.
    const showAirportMobileWebMap = useFeatureVariation(IMMEDIATE_FEATURES.AIRPORT_MOBILE_WEB_SHOW_MAP, {
        generateImpression: true,
    }) === OPTIMIZELY_FEATURE_ON;
    const onOpen = () => {
        trackSearchEditButtonClicked({
            parkingType: reduxState.parkingType,
            isMobile,
        });
        dispatch(setSearchComponentIsOpen(true));
    };
    return !isOpen ? (<Box>
            {/* {!showSEMEvent && (
            <> */}
            <ToggleWrapper onOpen={onOpen} showAirportMobileWebMap={showAirportMobileWebMap}/>
            <FilterSelection />
            {/* </>
        )} */}
        </Box>) : (<MobileSearchModal />);
};
